import React from 'react';
import constants from '../constants';

import "./StakeFormatter.css";

class StakeFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDelegate: false,
    }
    this.delegateWithUs = this.delegateWithUs.bind(this);
    this.hideDelegateWithUs = this.hideDelegateWithUs.bind(this);
  }

  delegateWithUs(e) {
    if (e) {
      e.stopPropagation();
    }
    // console.log("in delegateWithUs");
    if (this.state.showDelegate === false) {
      this.setState({showDelegate: true});
    } else {
      this.setState({showDelegate: false});
    }
  }

  hideDelegateWithUs(e) {
    if (e) {
      e.stopPropagation();
    }
    // console.log("in hideDelegateWithUs");
    this.setState({showDelegate: false});
  }

  render() {
    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a href={constants.urls.stakingHomeForValidator + this.props.address}
      target="_blank"><button className="animLink animLink linkBorder" id={"Stake" + this.props.address}
      >{this.props.label}</button></a></span>);

    // return (
    //   <React.Fragment>
    //     <button onClick={this.delegateWithUs} className="animLink animLink linkBorder">
    //       {this.props.label}
    //     </button>
    //     {this.state.showDelegate === true && <DelegateModal name={this.props.name} address={this.props.address}
    //       show={this.state.showDelegate} onHide={(e) => this.hideDelegateWithUs(e)} isSS={this.props.isSS} />}
    //   </React.Fragment>
    // );
  }
  // crocncl1s3hd63shz3q3vca8ajptewv3zt7jg6ed9kk2zr
  // return (<a href="https://station.terra.money/validator/terravaloper1alpf6snw2d76kkwjv3dp4l7pcl6cn9uyt0tcj9" 
  //   target="_blank" className="delegateLink animLink">Delegate to Smart Stake</a>);

}

export default StakeFormatter;



// WEBPACK FOOTER //
// ./src/components/StakeFormatter.js